import React, { useState, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import axios from "axios"
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { FaBars } from 'react-icons/fa'
import Table from 'react-bootstrap/Table'
import { apiURL, sitePath } from 'config/globals'
import Sidebar from 'components/Sidebar'
import Footer from 'components/Footer'
import { capitalize } from 'utils/String'
import { checkAuth } from 'utils/Auth'
import Spinner from 'react-bootstrap/Spinner'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'

const Dashboard = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    const [currentUser, setCurrentUser] = useState(false)
    const [dbSummary, setDbSummary] = useState([])
    const navigate = useNavigate()
    
    useEffect(() => {
        const start = async () => {
            setIsLoading(true)
            setCurrentUser(await checkAuth(navigate))
            await getDbSummary()
            setIsLoading(false)
        }
        start()
    }, [])

    const getDbSummary = async () => {
        const response = await axios.get(`${apiURL}/get-db-summary/`)
        setDbSummary(response.data)
    }

    function humanFileSize(bytes, si=false, dp=1) {
        const thresh = si ? 1000 : 1024;
      
        if (Math.abs(bytes) < thresh) {
          return bytes + ' B';
        }
      
        const units = si 
          ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] 
          : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
        let u = -1;
        const r = 10**dp;
      
        do {
          bytes /= thresh;
          ++u;
        } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
      
        return bytes.toFixed(dp) + ' ' + units[u];
    }

    return (
        <>
            <Sidebar selectedItem="dashboard" currentUser={currentUser} />
            <main>
                <div className="btn-toggle">
                    <FaBars />
                </div>
                <header>
                    <h1>UAB Open Labs</h1>
                </header>
                {isLoading
                    ? <Spinner animation="border" variant="secondary" />
                    : <>
                        <Tabs defaultActiveKey="views" className="mb-3">
                            <Tab eventKey="views" title="Vistes">
                                <Row>
                                    <Col lg xl="6">
                                        {dbSummary.views &&
                                            <Table striped bordered hover size="sm">
                                                <thead>
                                                    <tr>
                                                        <th>Nom</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {dbSummary.views?.map(viewItem => (
                                                        <tr key={viewItem.name}>
                                                            <td>
                                                                <Link to={`/views/${viewItem.name}`}>{capitalize(viewItem.name)}</Link>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        }
                                        {dbSummary.views &&
                                            <small>
                                                {dbSummary.views.length === 1 ? '1 vista' : `${dbSummary.views.length} vistes`}
                                            </small>
                                        }
                                    </Col>
                                </Row>
                            </Tab>
                            <Tab eventKey="tables" title="Taules">
                                <Row>
                                    <Col lg xl="6">
                                        {dbSummary.tables &&
                                            <Table striped bordered hover size="sm">
                                                <thead>
                                                    <tr>
                                                        <th>Nom</th>
                                                        <th>Registres</th>
                                                        <th>Mida</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {dbSummary.tables?.map(tableItem => (
                                                        <tr key={tableItem.name}>
                                                            <td>
                                                                <Link to={`/tables/${tableItem.name}`}>{tableItem.name}</Link>
                                                            </td>
                                                            <td>{tableItem.rows}</td>
                                                            <td>{humanFileSize(tableItem.size, true)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        }
                                        {dbSummary.tables &&
                                            <small>
                                                {dbSummary.tables.length === 1 ? '1 taula' : `${dbSummary.tables.length} taules`}
                                            </small>
                                        }
                                    </Col>
                                </Row>
                            </Tab>
                        </Tabs>
                      </>
                }
                <Footer user={currentUser} />
            </main>
        </>
    )
}

export default Dashboard
